import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "../core/Routes";
import "./App.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ProvideAuth } from "../core/hooks/useAuth";
import { ProvidePivotMobileBanner } from "../core/hooks/usePivotMobileBanner";
import useGTM from "@elgorditosalsero/react-gtm-hook";
import { googleTagManagerCode } from "../core/constants/strings";
import { ProvideContactInformation } from "../core/hooks/useContactInformation";
import { useAmplitudeExperiment } from "core/hooks/useAmplitudeExperiment";
import { useAuth } from "../core/hooks/useAuth";

function AmplitudeInit() {
  const { user, application } = useAuth();
  useAmplitudeExperiment({
    userId: user?.id ?? null,
    userProperties: {
      planType: application?.type,
      state: application?.state,
      carrierId: application?.carrierId,
    },
  });
  return null;
}

function App() {
  const { init, UseGTMHookProvider, sendDataToGTM } = useGTM();

  useEffect(() => init({ id: googleTagManagerCode }), []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    window.addEventListener("load", alertUser);
    return () => {
      window.removeEventListener("load", alertUser);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const alertUser = (_e: Event): void => {
    sendDataToGTM({ event: "appLoaded", value: true });
  };

  return (
    <ProvidePivotMobileBanner>
      <UseGTMHookProvider>
        <ProvideAuth>
          <AmplitudeInit />
          <ProvideContactInformation>
            <Router>
              <Header />
              <Routes />
              <Footer />
            </Router>
          </ProvideContactInformation>
        </ProvideAuth>
      </UseGTMHookProvider>
    </ProvidePivotMobileBanner>
  );
}

export default App;
